import { createHashHistory } from 'history';
import qs from 'query-string';
import React from 'react';
import { render } from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import './css/index.scss';
import './polyfills';
import configureStore from './store/configureStore';

/**
 * @typedef Config
 */
const defaultConfig = {
  rootSelector: '',
  apiUrl: '',
  thanksHeader: 'Thanks!',
  reservationHoldMinutes: '5',
  emailContentLabel: 'Additional Notes',
  itemEmailContent: {},
  /**
   * called when checkout finishes sucessfully
   * @param {Sale} sale - sale that was sent to the server
   * @param {string} email - email html string
   */
  onCheckout: (sale, email) => {}, // eslint-disable-line no-unused-vars
  limitThreshold: 50,
  guestMods: false,
  isFirstGuestPassholder: true,
  passholderLabel: 'Passholder',
  deepScrollBufferTop: 300,
  enablePromoCode: false,
  validateTimedPasses: false,
  validateTimedPassesIndividually: true,
  validationExceptions: [],
  hideBarcodeImages: false,
  allBarcodes: false,
  restrictModsToFirstItem: false,
  applyBenefitsToMods: false,
  limitToItemMaxQty: false
};

function validateConfig(config) {
  const nextConf = Object.assign({}, config);

  const rootElement = document.querySelector(nextConf.rootSelector);
  if (rootElement == null) {
    throw new Error('rootSelector must be a valid DOM selector');
  }

  return nextConf;
}

function offsetTop(el) {
  try {
    const rect = el.getBoundingClientRect();
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    return rect.top + scrollTop;
  } catch (o_O) {
    return undefined;
  }
}

const scrollTo = element => {
  const top = offsetTop(element);
  if (top === undefined) {
    return;
  }
  window.scrollTo(0, top);
};

export default function init(options = {}) {
  let config = Object.assign({}, defaultConfig, options);
  config = validateConfig(config);

  let { state = '{}' } = qs.parse(window.location.search);
  state = JSON.parse(state);

  const browserHistory = createHashHistory(window.location);
  const store = configureStore({ ...state, config }, browserHistory);
  const rootElement = document.querySelector(config.rootSelector);

  browserHistory.listen(() => scrollTo(rootElement));

  render(
    <Provider store={store}>
      <App history={browserHistory} rootElement={rootElement} />
    </Provider>,
    rootElement
  );
}
